// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e6d87eef","455":"5a1274b1","977":"bc321278"}[chunkId] + ".chunk.js";
};